import { render, staticRenderFns } from "./WarehousingStatistics.vue?vue&type=template&id=6b5ca5de&scoped=true"
import script from "./WarehousingStatistics.vue?vue&type=script&lang=js"
export * from "./WarehousingStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5ca5de",
  null
  
)

export default component.exports